export default __webpack_public_path__ + "static/media/find_diff.f3702e36.svg";